/* Privacy tooling (docs/plans/golive-privacy-tooling.md): labels, the break-glass report, the
 * audit viewer and the retention schedule. Tokens only. */

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.filters {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  align-items: end;
  gap: var(--space-3);
}

.meta {
  margin: 0;
  color: var(--graphite);
  font: var(--t-small);
}

.prose {
  max-width: 75ch;
  margin: 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.mono {
  font-family: var(--font-id);
  font-variant-numeric: tabular-nums;
}

.numbers {
  font-variant-numeric: tabular-nums;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.history {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.label {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: var(--space-3);
  min-height: 44px;
}

.checks {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  max-height: 320px;
  overflow-y: auto;
}

.chain {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}
